const VISIBLE_CLASSNAME = 'toaster--visible';

const ERROR_CLASSNAME = 'toaster--error';
const SUCCESS_CLASSNAME = 'toaster--success';

const OPEN_TIMEOUT = 30;
export const CLOSE_TIMEOUT = 3000;

let $toasterWrapper; // For reference purpose, do not use directly, call getWrapper()

/**
 * Provide the toaster wrapper and append it to the body
 *
 * @returns {jQuery} $toasterWrapper
 */
export function getWrapper() {
    if (!$toasterWrapper) {
        $toasterWrapper = $('<div/>', { class: 'toaster-wrapper' });
        $('body').append($toasterWrapper);
    }
    return $toasterWrapper;
}

/**
 * Close the provided toaster
 *
 * @param {jQuery} $toaster The toaster element
 */
export function closeToaster($toaster) {
    $toaster.parent().addClass('toaster--inactive');
    $toaster.removeClass(VISIBLE_CLASSNAME);
}

/**
 * Display a toaster with a type and a content
 *
 * @param {string} className The type className of the loader (ERROR_CLASSNAME|SUCCESS_CLASSNAME)
 * @param {string|jQuery} content The content displayed inside the toaster
 * @returns {jQuery} The toaster element
 */
export function displayToaster(className, content) {
    const $wrapper = getWrapper();
    const $toaster = $('<div/>', { class: `toaster ${className}` });
    const $closeButton = $('<button/>', { class: 'toaster__close btn-reset' });
    const closeToasterCallback = closeToaster.bind(null, $toaster);

    $closeButton.on('click', closeToasterCallback);
    $closeButton.append($('<i/>', { class: 'icon-close' }));
    $toaster.append([content, $closeButton]);
    $wrapper.removeClass('toaster--inactive');
    $wrapper.html($toaster);

    window.setTimeout(() => $toaster.addClass(VISIBLE_CLASSNAME), OPEN_TIMEOUT);
    window.setTimeout(closeToasterCallback, CLOSE_TIMEOUT);
    return $toaster;
}

/**
 * Display a success toaster a content
 *
 * @param {string|jQuery} content
 * @returns {jQuery} The toaster element
 */
export function displaySuccessToaster(content) {
    return displayToaster(SUCCESS_CLASSNAME, content);
}

/**
 * Display an error toaster a content
 *
 * @param {string|jQuery} content
 * @returns {jQuery} The toaster element
 */
export function displayErrorToaster(content) {
    return displayToaster(ERROR_CLASSNAME, content);
}
